import { render } from "./BookingReason.vue?vue&type=template&id=4b9f5aaa&scoped=true&ts=true"
import script from "./BookingReason.vue?vue&type=script&lang=ts"
export * from "./BookingReason.vue?vue&type=script&lang=ts"

import "./BookingReason.vue?vue&type=style&index=0&id=4b9f5aaa&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9f5aaa"]])

export default __exports__